import Vue from "vue";
import Router from "vue-router";
import CreateUmowa from "@/components/CreateUmowa";
import UmowaLeasing from "@/components/UmowaLeasing";
import UmowaPrzedstawiciel from "@/components/UmowaPrzedstawiciel";
import UmowaWspolpraca from "@/components/UmowaWspolpraca";
import UmowaGitara from "@/components/UmowaGitara";
import UmowaGitaraAneks from "@/components/UmowaGitaraAneks";
import UmowaGitaraAneks2 from "@/components/UmowaGitaraAneks2";
import UmowaMatematyka from "@/components/UmowaMatematyka";
import UmowaGrafika from "@/components/UmowaGrafika";
import UmowaProgramowanie from "@/components/UmowaProgramowanie";
import UmowaJudo from "@/components/UmowaJudo";
import UmowaAngielski from "@/components/UmowaAngielski";
import UmowaWspolpracaAngielski from "@/components/UmowaWspolpracaAngielski";
import Oswiadczenie from "@/components/Oswiadczenie";
import OswiadczeniePracownik from "@/components/OswiadczeniePracownik";
import UmowaWspolpracaGitara from "@/components/UmowaWspolpracaGitara";
import WypowiedzeniePlusUmowaGitara from "@/components/WypowiedzeniePlusUmowaGitara";
import WypowiedzenieGitara from "@/components/WypowiedzenieGitara";
import UmowaRysunek from "@/components/UmowaRysunek";
import UmowaMonitoring from "@/components/UmowaMonitoring";
import UmowaMatzM from "@/components/UmowaMatzM";
import UmowaRushsie from "@/components/UmowaRushsie";
import UmowaSzachy from "@/components/UmowaSzachy";
import UmowaKonsultantCC from "@/components/UmowaKonsultantCC";
import UmowaKonsultantInfolinia from "@/components/UmowaKonsultantInfolinia";
import UmowaNauczyciel from "@/components/UmowaNauczyciel";
import UmowaAsystentOrganizacyjny from "@/components/UmowaAsystentOrganizacyjny";
import UmowaMetodykiNauczyciel from "@/components/UmowaMetodykiNauczyciel";
import UmowaTworcaMaterialow from "@/components/UmowaTworcaMaterialow";
import UmowaAdministrowanieSerwera from "@/components/UmowaAdministrowanieSerwera";
import UmowaTworzenieProgramuNauczania from "@/components/UmowaTworzenieProgramuNauczania";
import UmowaMetodyk from "@/components/UmowaMetodyk";
import UmowaTworcaMaterialowiNauczyciel from "@/components/UmowaTworcaMaterialowiNauczyciel";
import UmowaTworzenieMap from "@/components/UmowaTworzenieMap";
import UmowaGrupaWsparciaTechnicznego from "@/components/UmowaGrupaWsparciaTechnicznego";
import UmowaKolonie from "@/components/UmowaKolonie";
import AneksUmowaKolonie from "@/components/AneksUmowaKolonie";
import KartaKwalifikacyjna from "@/components/KartaKwalifikacyjna";
import WzorUmowaNauczyciel from "@/components/WzorUmowaNauczyciel";
import UmowaKonsultantTurystyka from "@/components/UmowaKonsultantTurystyka";
import WzorUmowaKonsultantCC from "@/components/WzorUmowaKonsultantCC";
import UmowaMłodszyAsystentOrganizacyjny from "@/components/UmowaMłodszyAsystentOrganizacyjny";
import UmowaKierownik from "@/components/UmowaKierownik";
import UmowaInstruktorSnoNar from "@/components/UmowaInstruktorSnoNar";
import UmowaUniwersalna from "@/components/UmowaUniwersalna";
import UmowaKolonieLato from "@/components/UmowaKolonieLato";
import UmowaAneks from "@/components/UmowaAneks";
import UmowaWychowawca from "@/components/UmowaWychowawca";
import UmowaInstruktorWewnetrzny from "@/components/UmowaInstruktorWewnetrzny";
import UmowaInstruktorZewnetrzny from "@/components/UmowaInstruktorZewnetrzny";
import UmowaFoto from "@/components/UmowaFoto";
import UmowaPomocTechniczna from "@/components/UmowaPomocTechniczna";
import OswiadczenieKolonieLato from "@/components/OswiadczenieKolonieLato";
import KartaKwalifikacyjnaKolonie from "@/components/KartaKwalifikacyjnaKolonie";
import ArkuszMaterialow from "@/components/ArkuszMaterialow";
import UmowaGrupaWsparciaTechnicznego2023 from "@/components/UmowaGrupaWsparciaTechnicznego2023";
import UmowaKonsultantInfolinia2023 from "@/components/UmowaKonsultantInfolinia2023";
import UmowaKonsultantTurystyka2023 from "@/components/UmowaKonsultantTurystyka2023";
import UmowaKonsultantCC2025 from "@/components/UmowaKonsultantCC2025";
import UmowaKonsultantCCZdalny2023 from "@/components/UmowaKonsultantCCZdalny2023";
import WzorUmowaGrupaWsparciaTechnicznego2023 from "@/components/WzorUmowaGrupaWsparciaTechnicznego2023";
import WzorUmowaKonsultantTurystyka2023 from "@/components/WzorUmowaKonsultantTurystyka2023";
import WzorUmowaKonsultantInfolinia2023 from "@/components/WzorUmowaKonsultantInfolinia2023";
import WzorUmowaKonsultantCC2023 from "@/components/WzorUmowaKonsultantCC2023";
import WzorUmowaKonsultantCCZdalny2023 from "@/components/WzorUmowaKonsultantCCZdalny2023";
import UmowaAneksCentrala2023 from "@/components/UmowaAneksCentrala2023";
import UmowaAneksGenerowanie2023 from "@/components/UmowaAneksGenerowanie2023";
import OswiadczenieGenerowanie2023 from "@/components/OswiadczenieGenerowanie2023";
import UmowaNauczyciel2023 from "@/components/UmowaNauczyciel2023";
import UmowaTworcaMaterialow2023 from "@/components/UmowaTworcaMaterialow2023";
import UmowaAsystentOrganizacyjny2023 from "@/components/UmowaAsystentOrganizacyjny2023";
import UmowaAsystentOrganizacyjnyTelefon2023 from "@/components/UmowaAsystentOrganizacyjnyTelefon2023";
import UmowaMetodyk2023 from "@/components/UmowaMetodyk2023";
import UmowaMetodykTelefon2023 from "@/components/UmowaMetodykTelefon2023";
import UmowaTworzenieProgramuNauczania2023 from "@/components/UmowaTworzenieProgramuNauczania2023";
import UmowaTworcaMaterialowNauczycielMetodyk2023 from "@/components/UmowaTworcaMaterialowNauczycielMetodyk2023";
import UmowaTworcaMaterialowNauczycielMetodykTelefon2023 from "@/components/UmowaTworcaMaterialowNauczycielMetodykTelefon2023";
import UmowaMetodykiNauczyciel2023 from "@/components/UmowaMetodykiNauczyciel2023";
import UmowaMetodykiNauczycielTelefon2023 from "@/components/UmowaMetodykiNauczycielTelefon2023";
import UmowaTworzenieMap2023 from "@/components/UmowaTworzenieMap2023";
import WzorUmowaNauczyciel2023 from "@/components/WzorUmowaNauczyciel2023";
import UmowaMłodszyAsystentOrganizacyjny2023 from "@/components/UmowaMłodszyAsystentOrganizacyjny2023";
import ArkuszSkrot from "@/components/ArkuszSkrot";
import WzorOswiadczenieGenerowanie2023 from "@/components/WzorOswiadczenieGenerowanie2023";
import UmowaTworcaFabrykaMaterialow2023 from "@/components/UmowaTworcaFabrykaMaterialow2023";
import UmowaNauczycielAngielski2023 from "@/components/UmowaNauczycielAngielski2023";
import WypowiedzeniePorozumienie from "@/components/WypowiedzeniePorozumienie";
import WypowiedzeniePorozumienieENG from "@/components/WypowiedzeniePorozumienieENG";
import Wypowiedzenie from "@/components/Wypowiedzenie";
import WypowiedzenieENG from "@/components/WypowiedzenieENG";
import WypowiedzenieBezOkresWypo from "@/components/WypowiedzenieBezOkresWypo";
import WypowiedzenieBezOkresWypoENG from "@/components/WypowiedzenieBezOkresWypoENG";
import UmowaZimowiska2023 from "@/components/UmowaZimowiska2023";
import OswiadczenieGenerowanieAngielski2023 from "@/components/OswiadczenieGenerowanieAngielski2023";
import UmowaManagerPlacowkiEdukacyjnej2023 from "@/components/UmowaManagerPlacowkiEdukacyjnej2023";
import WypowiedzenieAngielski from "@/components/WypowiedzenieAngielski";
import WypowiedzeniePorozumienieAngielski from "@/components/WypowiedzeniePorozumienieAngielski";
import WypowiedzenieBezOkresWypoAngielski from "@/components/WypowiedzenieBezOkresWypoAngielski";
import WzorUmowaNauczycielAngielski2023 from "@/components/WzorUmowaNauczycielAngielski2023";
import UmowaKolonie2023 from "@/components/UmowaKolonie2023";
import AneksKolonie2023 from "@/components/AneksKolonie2023";
import UmowaAngLektor2023 from "@/components/UmowaAngLektor2023";
import UmowaLektor2023 from "@/components/UmowaLektor2023";
import UmowaAneksProfi2023 from "@/components/UmowaAneksProfi2023";
import UmowaLektorB2B2023 from "@/components/UmowaLektorB2B2023";
import UmowaMetodykProfi from "@/components/UmowaMetodykProfi";
import UmowaPromocjaProfi from "@/components/UmowaPromocjaProfi";
import UmowaBOKProfi from "@/components/UmowaBOKProfi";
import UmowaTechniczniCPProfi from "@/components/UmowaTechniczniCPProfi";
import UmowaTechniczniKBProfi from "@/components/UmowaTechniczniKBProfi";
import UmowaTechniczniOMProfi from "@/components/UmowaTechniczniOMProfi";
import WzorUmowaZlecenieProfi from "@/components/WzorUmowaZlecenieProfi";
import UmowaFotoZimowiska2023 from "@/components/UmowaFotoZimowiska2023";
import UmowaWychowawcaZimowiska2023 from "@/components/UmowaWychowawcaZimowiska2023";
import UmowaPomocTechnicznaZimowiska2023 from "@/components/UmowaPomocTechnicznaZimowiska2023";
import UmowaKierownikZimowiska2023 from "@/components/UmowaKierownikZimowiska2023";
import UmowaInstruktorWewnetrznyZimowiska2023 from "@/components/UmowaInstruktorWewnetrznyZimowiska2023";
import UmowaInstruktorZewnetrznyZimowiska2023 from "@/components/UmowaInstruktorZewnetrznyZimowiska2023";
import WzorUmowaLektorB2B2023 from "@/components/WzorUmowaLektorB2B2023";
import WzorUmowaTechniczniCPProfi from "@/components/WzorUmowaTechniczniCPProfi";
import WzorUmowaManagerPlacowkiEdukacyjnej2023 from "@/components/WzorUmowaManagerPlacowkiEdukacyjnej2023";
import UmowaSpecjalistaRozwojSieciSprzedazy2023 from "@/components/UmowaSpecjalistaRozwojSieciSprzedazy2023";
import WzorUmowaSpecjalistaRozwojSieciSprzedazy2023 from "@/components/WzorUmowaSpecjalistaRozwojSieciSprzedazy2023";
import UmowaAnimatorRozwojSieciSprzedazy2023 from "@/components/UmowaAnimatorRozwojSieciSprzedazy2023";
import UmowaLektorB2BAngielski2024 from "@/components/UmowaLektorB2BAngielski2024";
import UmowaLektorAngielski2023 from "@/components/UmowaLektorAngielski2023";
import UmowaKonsultantCCProfi from "@/components/UmowaKonsultantCCProfi";
import UmowaKonsultantInfoliniaProfi from "@/components/UmowaKonsultantInfoliniaProfi";
import UmowaMlodszySpecjalistaSekcjaSzkolna2023 from "@/components/UmowaMlodszySpecjalistaSekcjaSzkolna2023";
import WzorUmowaPomocTechnicznaZimowiska2023 from "@/components/WzorUmowaPomocTechnicznaZimowiska2023";
import UmowaHostessaSieciSprzedazy2023 from "@/components/UmowaHostessaSieciSprzedazy2023";
import UmowaHostessaSieciSprzedazyBOK2023 from "@/components/UmowaHostessaSieciSprzedazyBOK2023";
import UmowaAnimatorBOK2023 from "@/components/UmowaAnimatorBOK2023";
import WzorUmowaHostessaSieciSprzedazy2023 from "@/components/WzorUmowaHostessaSieciSprzedazy2023";
import WzorUmowaAnimatorRozwojSieciSprzedazy2023 from "@/components/WzorUmowaAnimatorRozwojSieciSprzedazy2023";
import WzorUmowaFotoZimowiska2023 from "@/components/WzorUmowaFotoZimowiska2023";
import WzorUmowaWychowawcaZimowiska2023 from "@/components/WzorUmowaWychowawcaZimowiska2023";
import WzorUmowaKierownikZimowiska2023 from "@/components/WzorUmowaKierownikZimowiska2023";
import WzorUmowaInstruktorWewnetrznyZimowiska2023 from "@/components/WzorUmowaInstruktorWewnetrznyZimowiska2023";
import WzorUmowaInstruktorZewnetrznyZimowiska2023 from "@/components/WzorUmowaInstruktorZewnetrznyZimowiska2023";
import UmowaManager from "@/components/UmowaManager";
import UmowaAnimatorEdukacja from "@/components/UmowaAnimatorEdukacja";
import UmowaHostessaEdukacja from "@/components/UmowaHostessaEdukacja";
import WypowiedzenieB2B from "@/components/WypowiedzenieB2B";
import WypowiedzenieBezOkresWypoB2B from "@/components/WypowiedzenieBezOkresWypoB2B";
import WypowiedzeniePorozumienieB2B from "@/components/WypowiedzeniePorozumienieB2B";
import WypowiedzenieB2BTM from "@/components/WypowiedzenieB2BTM";
import WypowiedzenieBezOkresWypoB2BTM from "@/components/WypowiedzenieBezOkresWypoB2BTM";
import WypowiedzeniePorozumienieB2BTM from "@/components/WypowiedzeniePorozumienieB2BTM";
import UmowaKierownik2023 from "@/components/UmowaKierownik2023";
import UmowaWychowawca2023 from "@/components/UmowaWychowawca2023";
import RegulaminKolonie2023 from "@/components/RegulaminKolonie2023";
import UmowaFotograf2023 from "@/components/UmowaFotograf2023";
import UmowaPomocTechniczna2023 from "@/components/UmowaPomocTechniczna2023";
import UmowaKoordynator from "@/components/UmowaKoordynator";
import UmowaKoordynatorSprzedaz from "@/components/UmowaKoordynatorSprzedaz";
import KartaBagaz from "@/components/KartaBagaz";
import UmowaInstruktor2023 from "@/components/UmowaInstruktor2023";
import UmowaTeamLeader2023 from "@/components/UmowaTeamLeader2023";
import UmowaSpecjalistaSprzedaz from "@/components/UmowaSpecjalistaSprzedaz";
import UmowaKierownikProfi2023 from "@/components/UmowaKierownikProfi2023";
import UmowaWychowawcaProfi2023 from "@/components/UmowaWychowawcaProfi2023";
import UmowaZlecenieRegionAbcd from "@/components/UmowaZlecenieRegionAbcd";
import UmowaB2BRegionAbcd from "@/components/UmowaB2BRegionAbcd";
import UmowaZlecenieRegionAbcdMG from "@/components/UmowaZlecenieRegionAbcdMG";
import UmowaB2BRegionAbcdMG from "@/components/UmowaB2BRegionAbcdMG";
import WzorUmowaZlecenieRegionAbcd from "@/components/WzorUmowaZlecenieRegionAbcd";
import WzorUmowaB2BRegionAbcd from "@/components/WzorUmowaB2BRegionAbcd";
import OswiadczenieGenerowanieRegionAbcd from "@/components/OswiadczenieGenerowanieRegionAbcd";
import WypowiedzenieRegion from "@/components/WypowiedzenieRegion";
import WypowiedzeniePorozumienieRegion from "@/components/WypowiedzeniePorozumienieRegion";
import WypowiedzenieBezOkresWypoRegion from "@/components/WypowiedzenieBezOkresWypoRegion";
import UmowaMetodyk2024 from "@/components/UmowaMetodyk2024";
import UmowaNauczycielOnline2024 from "@/components/UmowaNauczycielOnline2024";
import UmowaLektor2024 from "@/components/UmowaLektor2024";
import UmowaTworcaTM2024 from '@/components/UmowaTworcaTM2024';
import UmowaTworcaFabrykaMaterialow2024 from '@/components/UmowaTworcaFabrykaMaterialow2024';
import UmowaTworcaMaterialowNauczycielMetodyk2024 from '@/components/UmowaTworcaMaterialowNauczycielMetodyk2024';
import OswiadczenieGenerowanie2024 from '@/components/OswiadczenieGenerowanie2024';
import WzorOswiadczenieGenerowanie2024 from '@/components/WzorOswiadczenieGenerowanie2024';
import WzorUmowaTworca2024 from '@/components/WzorUmowaTworca2024';
import WzorUmowaNauczycielOnline2024 from '@/components/WzorUmowaNauczycielOnline2024';
import WzorUmowaTworcaMaterialowNauczycielMetodyk2024 from '@/components/WzorUmowaTworcaMaterialowNauczycielMetodyk2024';
import WzorUmowaMetodyk2024 from '@/components/WzorUmowaMetodyk2024';
import WzorUmowaTworcaFabrykaMaterialow2024 from '@/components/WzorUmowaTworcaFabrykaMaterialow2024';
import UmowaLektorB2B2024 from '@/components/UmowaLektorB2B2024';
import UmowaMetodykB2B2024 from '@/components/UmowaMetodykB2B2024';
import UmowaNauczycielAngielski2024 from '@/components/UmowaNauczycielAngielski2024';
import UmowaLektorAngielski2024 from '@/components/UmowaLektorAngielski2024';
import UmowaFundacja from '@/components/UmowaFundacja';
import UmowaTutoreKlient from '@/components/UmowaTutoreKlient';
import OswiadczenieGenerowanie2024Tutore from '@/components/OswiadczenieGenerowanie2024Tutore';
import UmowaAnimatorEdukacjaTutore from '@/components/UmowaAnimatorEdukacjaTutore';
import OswiadczenieGenerowanieRegionAbcdTutore from '@/components/OswiadczenieGenerowanieRegionAbcdTutore';
import OswiadczenieGenerowanieProfi2024 from '@/components/OswiadczenieGenerowanieProfi2024';
import UmowaNauczycielOnlineTutore2024 from '@/components/UmowaNauczycielOnlineTutore2024';
import UmowaMetodykTutore2024 from '@/components/UmowaMetodykTutore2024';
import UmowaTworcaMaterialowNauczycielMetodykTutore2024 from '@/components/UmowaTworcaMaterialowNauczycielMetodykTutore2024';
import WypowiedzenieTutore from '@/components/WypowiedzenieTutore';
import WypowiedzenieBezOkresWypoTutore from '@/components/WypowiedzenieBezOkresWypoTutore';
import WypowiedzeniePorozumienieTutore from '@/components/WypowiedzeniePorozumienieTutore';
import UmowaTworcaFabrykaMaterialowTutore2024 from '@/components/UmowaTworcaFabrykaMaterialowTutore2024';
import UmowaTworcaTD2024 from '@/components/UmowaTworcaTD2024';
import UmowaAnimatorTutore from '@/components/UmowaAnimatorTutore';
import UmowaNauczycielOnlineTutore2024ABCD from '@/components/UmowaNauczycielOnlineTutore2024ABCD';
import UmowaHostessaB2B2024 from '@/components/UmowaHostessaB2B2024';
import AneksB2B from '@/components/AneksB2B';
import UmowaPromotorMarki from '@/components/UmowaPromotorMarki';
import AneksTutorePoland2024 from '@/components/AneksTutorePoland2024';
import AneksTutorePoland2024ENG from '@/components/AneksTutorePoland2024ENG';
import AneksTutore2024 from '@/components/AneksTutore2024';
import AneksTutore2024ENG from '@/components/AneksTutore2024ENG';
import AneksB2BTutorePoland from '@/components/AneksB2BTutorePoland';
import AneksB2BTutorePolandENG from '@/components/AneksB2BTutorePolandENG';
import AneksB2BTutore from '@/components/AneksB2BTutore';
import AneksB2BTutoreENG from '@/components/AneksB2BTutoreENG';
import UmowaHostessaTutorePolandB2B from '@/components/UmowaHostessaTutorePolandB2B';
import WypowiedzenieRegionTutore from '@/components/WypowiedzenieRegionTutore';
import WypowiedzeniePorozumienieRegionTutore from '@/components/WypowiedzeniePorozumienieRegionTutore';
import OswiadczenieGenerowanie2024TutoreMale from '@/components/OswiadczenieGenerowanie2024TutoreMale';
import OswiadczenieGenerowanie2024AnimatorTutoreDuze from '@/components/OswiadczenieGenerowanie2024AnimatorTutoreDuze';
import OswiadczenieGenerowanieRegionAbcdTutoreDuze from '@/components/OswiadczenieGenerowanieRegionAbcdTutoreDuze';
import AneksNauczycielAnimatorTutoreMale from '@/components/AneksNauczycielAnimatorTutoreMale';
import UmowaNauczycielLektorAnimatorTutoreMale from '@/components/UmowaNauczycielLektorAnimatorTutoreMale';
import AneksNauczycielAnimatorTutoreDuze from '@/components/AneksNauczycielAnimatorTutoreDuze';
import UmowaNauczycielLektorAnimatorTutoreDuze from '@/components/UmowaNauczycielLektorAnimatorTutoreDuze';
import UmowaAnimatorTutoreMale from '@/components/UmowaAnimatorTutoreMale';
import UmowaAnimatorTutoreDuze from '@/components/UmowaAnimatorTutoreDuze';
import AneksAnimatorTutoreMale from '@/components/AneksAnimatorTutoreMale';
import AneksAnimatorTutoreDuze from '@/components/AneksAnimatorTutoreDuze';
import OswiadczenieGenerowanieAngielskiZmienione2023 from '@/components/OswiadczenieGenerowanieAngielskiZmienione2023';
import UmowaAneksTechniczni2024 from '@/components/UmowaAneksTechniczni2024';
import AneksPustyUOP from '@/components/AneksPustyUOP';
import AneksStanowiskoWynagrodzenieUOP from '@/components/AneksStanowiskoWynagrodzenieUOP';
import AneksMiejsceRodzajPracyUOP from '@/components/AneksMiejsceRodzajPracyUOP';
import PorozumienieUOP from '@/components/PorozumienieUOP';
import PorozumienieRegulaminUOP from '@/components/PorozumienieRegulaminUOP';
import UmowaNauczyciel2024 from '@/components/UmowaNauczyciel2024';
import UmowaNauczyciel2024eTutorPlus from '@/components/UmowaNauczyciel2024eTutorPlus.vue';
import UmowaNauczyciel2025eTutorPlus from '@/components/UmowaNauczyciel2025eTutorPlus.vue';
import AneksNauczyciel2024eTutorPlus from '@/components/AneksNauczyciel2024eTutorPlus.vue';
import AneksB2BNauczyciel2024eTutorPlus from '@/components/AneksB2BNauczyciel2024eTutorPlus.vue';
import UmowaNauczyciel2024ENG from '@/components/UmowaNauczyciel2024ENG';
import UmowaNauczyciel2024TutoreMale from "../components/UmowaNauczyciel2024TutoreMale.vue";
import UmowaNauczyciel2024TutoreMaleENG from "../components/UmowaNauczyciel2024TutoreMaleENG.vue";
import UmowaB2BNauczyciel2024 from "../components/UmowaB2BNauczyciel2024.vue";
import UmowaB2BNauczyciel2024eTutorPlus from "../components/UmowaB2BNauczyciel2024eTutorPlus.vue";
import UmowaB2BNauczyciel2025eTutorPlus from "../components/UmowaB2BNauczyciel2025eTutorPlus.vue";
import UmowaB2BNauczyciel2024ENG from "../components/UmowaB2BNauczyciel2024ENG.vue";
import UmowaB2BNauczyciel2024TutoreMale from "../components/UmowaB2BNauczyciel2024TutoreMale.vue";
import UmowaB2BNauczyciel2024TutoreMaleENG from "../components/UmowaB2BNauczyciel2024TutoreMaleENG.vue";
import UmowaB2BMetodyk2024TD from "../components/UmowaB2BMetodyk2024TD.vue";
import UmowaB2BMetodyk2024TM from "../components/UmowaB2BMetodyk2024TM.vue";
import WypowiedzenieZOkresWypo from "../components/WypowiedzenieZOkresWypo.vue";
import AneksPorozumienieZlecenie from '@/components/AneksPorozumienieZlecenie';
import AneksPorozumienieB2B from '@/components/AneksPorozumienieB2B';
import WypowiedzenieZOkresWypoB2B from "../components/WypowiedzenieZOkresWypoB2B.vue";
import WypowiedzenieZOkresWypoB2BTM from "../components/WypowiedzenieZOkresWypoB2BTM.vue";
import OswiadczenieETutor from "../components/OswiadczenieETutor.vue";
import OswiadczenieILI from "../components/OswiadczenieILI.vue";
import Oswiadczenie25TD from "../components/Oswiadczenie25TD.vue";
import Oswiadczenie25TM from "../components/Oswiadczenie25TM.vue";
import Oswiadczenie25TDENG from "../components/Oswiadczenie25TDENG.vue";
import Oswiadczenie25TMENG from "../components/Oswiadczenie25TMENG.vue";
import Oswiadczenie25LM from "../components/LangMedia/Oswiadczenie25LM.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "CreateUmowa",
      component: CreateUmowa,
      props: true
    },
    {
      path: "/UmowaLeasing",
      name: "UmowaLeasing",
      component: UmowaLeasing,
      props: true
    },
    {
      path: "/UmowaPrzedstawiciel",
      name: "UmowaPrzedstawiciel",
      component: UmowaPrzedstawiciel,
      props: true
    },
    {
      path: "/UmowaWspolpraca",
      name: "UmowaWspolpraca",
      component: UmowaWspolpraca,
      props: true
    },
    {
      path: "/UmowaGitara",
      name: "UmowaGitara",
      component: UmowaGitara,
      props: true
    },
    {
      path: "/UmowaGitaraAneks",
      name: "UmowaGitaraAneks",
      component: UmowaGitaraAneks,
      props: true
    },
    {
      path: "/UmowaGitaraAneks2",
      name: "UmowaGitaraAneks2",
      component: UmowaGitaraAneks2,
      props: true
    },
    {
      path: "/UmowaMatematyka",
      name: "UmowaMatematyka",
      component: UmowaMatematyka,
      props: true
    },
    {
      path: "/UmowaProgramowanie",
      name: "UmowaProgramowanie",
      component: UmowaProgramowanie,
      props: true
    },
    {
      path: "/UmowaGrafika",
      name: "UmowaGrafika",
      component: UmowaGrafika,
      props: true
    },
    {
      path: "/UmowaJudo",
      name: "UmowaJudo",
      component: UmowaJudo,
      props: true
    },
    {
      path: "/UmowaAngielski",
      name: "UmowaAngielski",
      component: UmowaAngielski,
      props: true
    },
    {
      path: "/UmowaWspolpracaAngielski",
      name: "UmowaWspolpracaAngielski",
      component: UmowaWspolpracaAngielski,
      props: true
    },
    {
      path: "/Oswiadczenie",
      name: "Oswiadczenie",
      component: Oswiadczenie,
      props: true
    },
    {
      path: "/OswiadczeniePracownik",
      name: "OswiadczeniePracownik",
      component: OswiadczeniePracownik,
      props: true
    },
    {
      path: "/UmowaWspolpracaGitara",
      name: "UmowaWspolpracaGitara",
      component: UmowaWspolpracaGitara,
      props: true
    },
    {
      path: "/WypowiedzeniePlusUmowaGitara",
      name: "WypowiedzeniePlusUmowaGitara",
      component: WypowiedzeniePlusUmowaGitara,
      props: true
    },
    {
      path: "/WypowiedzenieGitara",
      name: "WypowiedzenieGitara",
      component: WypowiedzenieGitara,
      props: true
    },
    {
      path: "/UmowaRysunek",
      name: "UmowaRysunek",
      component: UmowaRysunek,
      props: true
    },
    {
      path: "/UmowaMonitoring",
      name: "UmowaMonitoring",
      component: UmowaMonitoring,
      props: true
    },
    {
      path: "/UmowaMatzM",
      name: "UmowaMatzM",
      component: UmowaMatzM,
      props: true
    },
    {
      path: "/UmowaRushsie",
      name: "UmowaRushsie",
      component: UmowaRushsie,
      props: true
    },
    {
      path: "/UmowaSzachy",
      name: "UmowaSzachy",
      component: UmowaSzachy,
      props: true
    },
    {
      path: "/UmowaKonsultantCC",
      name: "UmowaKonsultantCC",
      component: UmowaKonsultantCC,
      props: true
    },
    {
      path: "/UmowaKonsultantInfolinia",
      name: "UmowaKonsultantInfolinia",
      component: UmowaKonsultantInfolinia,
      props: true
    },
    {
      path: "/UmowaNauczyciel",
      name: "UmowaNauczyciel",
      component: UmowaNauczyciel,
      props: true
    },
    {
      path: "/UmowaAsystentOrganizacyjny",
      name: "UmowaAsystentOrganizacyjny",
      component: UmowaAsystentOrganizacyjny,
      props: true
    },
    {
      path: "/UmowaMetodykiNauczyciel",
      name: "UmowaMetodykiNauczyciel",
      component: UmowaMetodykiNauczyciel,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialow",
      name: "UmowaTworcaMaterialow",
      component: UmowaTworcaMaterialow,
      props: true
    },
    {
      path: "/UmowaAdministrowanieSerwera",
      name: "UmowaAdministrowanieSerwera",
      component: UmowaAdministrowanieSerwera,
      props: true
    },
    {
      path: "/UmowaTworzenieProgramuNauczania",
      name: "UmowaTworzenieProgramuNauczania",
      component: UmowaTworzenieProgramuNauczania,
      props: true
    },
    {
      path: "/UmowaMetodyk",
      name: "UmowaMetodyk",
      component: UmowaMetodyk,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialowiNauczyciel",
      name: "UmowaTworcaMaterialowiNauczyciel",
      component: UmowaTworcaMaterialowiNauczyciel,
      props: true
    },
    {
      path: "/UmowaTworzenieMap",
      name: "UmowaTworzenieMap",
      component: UmowaTworzenieMap,
      props: true
    },
    {
      path: "/UmowaGrupaWsparciaTechnicznego",
      name: "UmowaGrupaWsparciaTechnicznego",
      component: UmowaGrupaWsparciaTechnicznego,
      props: true
    },
    {
      path: "/UmowaKolonie",
      name: "UmowaKolonie",
      component: UmowaKolonie,
      props: true
    },
    {
      path: "/UmowaKolonieLato",
      name: "UmowaKolonieLato",
      component: UmowaKolonieLato,
      props: true
    },
    {
      path: "/AneksUmowaKolonie",
      name: "AneksUmowaKolonie",
      component: AneksUmowaKolonie,
      props: true
    },
    {
      path: "/KartaKwalifikacyjna",
      name: "KartaKwalifikacyjna",
      component: KartaKwalifikacyjna,
      props: true
    },
    {
      path: "/WzorUmowaNauczyciel",
      name: "WzorUmowaNauczyciel",
      component: WzorUmowaNauczyciel,
      props: true
    },
    {
      path: "/UmowaKonsultantTurystyka",
      name: "UmowaKonsultantTurystyka",
      component: UmowaKonsultantTurystyka,
      props: true
    },
    {
      path: "/WzorUmowaKonsultantCC",
      name: "WzorUmowaKonsultantCC",
      component: WzorUmowaKonsultantCC,
      props: true
    },
    {
      path: "/UmowaMłodszyAsystentOrganizacyjny",
      name: "UmowaMłodszyAsystentOrganizacyjny",
      component: UmowaMłodszyAsystentOrganizacyjny,
      props: true
    },
    {
      path: "/UmowaKierownik",
      name: "UmowaKierownik",
      component: UmowaKierownik,
      props: true
    },
    {
      path: "/UmowaInstruktorSnoNar",
      name: "UmowaInstruktorSnoNar",
      component: UmowaInstruktorSnoNar,
      props: true
    },
    {
      path: "/UmowaAneks",
      name: "UmowaAneks",
      component: UmowaAneks,
      props: true
    },
    {
      path: "/UmowaUniwersalna",
      name: "/UmowaUniwersalna",
      component: UmowaUniwersalna,
      props: true
    },
    {
      path: "/UmowaWychowawca",
      name: "/UmowaWychowawca",
      component: UmowaWychowawca,
      props: true
    },
    {
      path: "/UmowaInstruktorWewnetrzny",
      name: "/UmowaInstruktorWewnetrzny",
      component: UmowaInstruktorWewnetrzny,
      props: true
    },
    {
      path: "/UmowaInstruktorZewnetrzny",
      name: "/UmowaInstruktorZewnetrzny",
      component: UmowaInstruktorZewnetrzny,
      props: true
    },
    {
      path: "/UmowaFoto",
      name: "/UmowaFoto",
      component: UmowaFoto,
      props: true
    },
    {
      path: "/UmowaPomocTechniczna",
      name: "/UmowaPomocTechniczna",
      component: UmowaPomocTechniczna,
      props: true
    },
    {
      path: "/OswiadczenieKolonieLato",
      name: "/OswiadczenieKolonieLato",
      component: OswiadczenieKolonieLato,
      props: true
    },
    {
      path: "/KartaKwalifikacyjnaKolonie",
      name: "KartaKwalifikacyjnaKolonie",
      component: KartaKwalifikacyjnaKolonie,
      props: true
    },
    {
      path: "/ArkuszMaterialow",
      name: "ArkuszMaterialow",
      component: ArkuszMaterialow,
      props: true
    },
    {
      path: "/UmowaGrupaWsparciaTechnicznego2023",
      name: "UmowaGrupaWsparciaTechnicznego2023",
      component: UmowaGrupaWsparciaTechnicznego2023,
      props: true
    },
    {
      path: "/UmowaKonsultantInfolinia2023",
      name: "UmowaKonsultantInfolinia2023",
      component: UmowaKonsultantInfolinia2023,
      props: true
    },
    {
      path: "/UmowaKonsultantTurystyka2023",
      name: "UmowaKonsultantTurystyka2023",
      component: UmowaKonsultantTurystyka2023,
      props: true
    },
    {
      path: "/UmowaKonsultantCC2025",
      name: "UmowaKonsultantCC2025",
      component: UmowaKonsultantCC2025,
      props: true
    },
    {
      path: "/UmowaKonsultantCCZdalny2023",
      name: "UmowaKonsultantCCZdalny2023",
      component: UmowaKonsultantCCZdalny2023,
      props: true
    },
    {
      path: "/WzorUmowaGrupaWsparciaTechnicznego2023",
      name: "WzorUmowaGrupaWsparciaTechnicznego2023",
      component: WzorUmowaGrupaWsparciaTechnicznego2023,
      props: true
    },
    {
      path: "/WzorUmowaKonsultantTurystyka2023",
      name: "WzorUmowaKonsultantTurystyka2023",
      component: WzorUmowaKonsultantTurystyka2023,
      props: true
    },
    {
      path: "/WzorUmowaKonsultantInfolinia2023",
      name: "WzorUmowaKonsultantInfolinia2023",
      component: WzorUmowaKonsultantInfolinia2023,
      props: true
    },
    {
      path: "/WzorUmowaKonsultantCC2023",
      name: "WzorUmowaKonsultantCC2023",
      component: WzorUmowaKonsultantCC2023,
      props: true
    },
    {
      path: "/WzorUmowaKonsultantCCZdalny2023",
      name: "WzorUmowaKonsultantCCZdalny2023",
      component: WzorUmowaKonsultantCCZdalny2023,
      props: true
    },
    {
      path: "/UmowaAneksCentrala2023",
      name: "UmowaAneksCentrala2023",
      component: UmowaAneksCentrala2023,
      props: true
    },
    {
      path: "/UmowaAneksGenerowanie2023",
      name: "UmowaAneksGenerowanie2023",
      component: UmowaAneksGenerowanie2023,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanie2023",
      name: "OswiadczenieGenerowanie2023",
      component: OswiadczenieGenerowanie2023,
      props: true
    },
    {
      path: "/UmowaNauczyciel2023",
      name: "UmowaNauczyciel2023",
      component: UmowaNauczyciel2023,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialow2023",
      name: "UmowaTworcaMaterialow2023",
      component: UmowaTworcaMaterialow2023,
      props: true
    },
    {
      path: "/UmowaAsystentOrganizacyjny2023",
      name: "UmowaAsystentOrganizacyjny2023",
      component: UmowaAsystentOrganizacyjny2023,
      props: true
    },
    {
      path: "/UmowaAsystentOrganizacyjnyTelefon2023",
      name: "UmowaAsystentOrganizacyjnyTelefon2023",
      component: UmowaAsystentOrganizacyjnyTelefon2023,
      props: true
    },
    {
      path: "/UmowaMetodyk2023",
      name: "UmowaMetodyk2023",
      component: UmowaMetodyk2023,
      props: true
    },
    {
      path: "/UmowaMetodykTelefon2023",
      name: "UmowaMetodykTelefon2023",
      component: UmowaMetodykTelefon2023,
      props: true
    },
    {
      path: "/UmowaTworzenieProgramuNauczania2023",
      name: "UmowaTworzenieProgramuNauczania2023",
      component: UmowaTworzenieProgramuNauczania2023,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialowNauczycielMetodyk2023",
      name: "UmowaTworcaMaterialowNauczycielMetodyk2023",
      component: UmowaTworcaMaterialowNauczycielMetodyk2023,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialowNauczycielMetodykTelefon2023",
      name: "UmowaTworcaMaterialowNauczycielMetodykTelefon2023",
      component: UmowaTworcaMaterialowNauczycielMetodykTelefon2023,
      props: true
    },
    {
      path: "/UmowaMetodykiNauczyciel2023",
      name: "UmowaMetodykiNauczyciel2023",
      component: UmowaMetodykiNauczyciel2023,
      props: true
    },
    {
      path: "/UmowaMetodykiNauczycielTelefon2023",
      name: "UmowaMetodykiNauczycielTelefon2023",
      component: UmowaMetodykiNauczycielTelefon2023,
      props: true
    },
    {
      path: "/UmowaTworzenieMap2023",
      name: "UmowaTworzenieMap2023",
      component: UmowaTworzenieMap2023,
      props: true
    },
    {
      path: "/WzorUmowaNauczyciel2023",
      name: "WzorUmowaNauczyciel2023",
      component: WzorUmowaNauczyciel2023,
      props: true
    },
    {
      path: "/UmowaMłodszyAsystentOrganizacyjny2023",
      name: "UmowaMłodszyAsystentOrganizacyjny2023",
      component: UmowaMłodszyAsystentOrganizacyjny2023,
      props: true
    },
    {
      path: "/ArkuszSkrot",
      name: "ArkuszSkrot",
      component: ArkuszSkrot,
      props: true
    },
    {
      path: "/WzorOswiadczenieGenerowanie2023",
      name: "WzorOswiadczenieGenerowanie2023",
      component: WzorOswiadczenieGenerowanie2023,
      props: true
    },
    {
      path: "/UmowaTworcaFabrykaMaterialow2023",
      name: "UmowaTworcaFabrykaMaterialow2023",
      component: UmowaTworcaFabrykaMaterialow2023,
      props: true
    },
    {
      path: "/UmowaNauczycielAngielski2023",
      name: "UmowaNauczycielAngielski2023",
      component: UmowaNauczycielAngielski2023,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienie",
      name: "WypowiedzeniePorozumienie",
      component: WypowiedzeniePorozumienie,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieENG",
      name: "WypowiedzeniePorozumienieENG",
      component: WypowiedzeniePorozumienieENG,
      props: true
    },
    {
      path: "/Wypowiedzenie",
      name: "Wypowiedzenie",
      component: Wypowiedzenie,
      props: true
    },
    {
      path: "/WypowiedzenieENG",
      name: "WypowiedzenieENG",
      component: WypowiedzenieENG,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypo",
      name: "WypowiedzenieBezOkresWypo",
      component: WypowiedzenieBezOkresWypo,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoENG",
      name: "WypowiedzenieBezOkresWypoENG",
      component: WypowiedzenieBezOkresWypoENG,
      props: true
    },
    {
      path: "/UmowaZimowiska2023",
      name: "UmowaZimowiska2023",
      component: UmowaZimowiska2023,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieAngielski2023",
      name: "OswiadczenieGenerowanieAngielski2023",
      component: OswiadczenieGenerowanieAngielski2023,
      props: true
    },
    {
      path: "/UmowaManagerPlacowkiEdukacyjnej2023",
      name: "UmowaManagerPlacowkiEdukacyjnej2023",
      component: UmowaManagerPlacowkiEdukacyjnej2023,
      props: true
    },
    {
      path: "/WypowiedzenieAngielski",
      name: "WypowiedzenieAngielski",
      component: WypowiedzenieAngielski,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieAngielski",
      name: "WypowiedzeniePorozumienieAngielski",
      component: WypowiedzeniePorozumienieAngielski,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoAngielski",
      name: "WypowiedzenieBezOkresWypoAngielski",
      component: WypowiedzenieBezOkresWypoAngielski,
      props: true
    },
    {
      path: "/WzorUmowaNauczycielAngielski2023",
      name: "WzorUmowaNauczycielAngielski2023",
      component: WzorUmowaNauczycielAngielski2023,
      props: true
    },
    {
      path: "/WzorUmowaLektorB2B2023",
      name: "WzorUmowaLektorB2B2023",
      component: WzorUmowaLektorB2B2023,
      props: true
    },
    {
      path: "/UmowaKolonie2023",
      name: "UmowaKolonie2023",
      component: UmowaKolonie2023,
      props: true
    },
    {
      path: "/AneksKolonie2023",
      name: "AneksKolonie2023",
      component: AneksKolonie2023,
      props: true
    },
    {
      path: "/UmowaAngLektor2023",
      name: "UmowaAngLektor2023",
      component: UmowaAngLektor2023,
      props: true
    },
    {
      path: "/UmowaLektor2023",
      name: "UmowaLektor2023",
      component: UmowaLektor2023,
      props: true
    },
    {
      path: "/UmowaAneksProfi2023",
      name: "UmowaAneksProfi2023",
      component: UmowaAneksProfi2023,
      props: true
    },
    {
      path: "/UmowaLektorB2B2023",
      name: "UmowaLektorB2B2023",
      component: UmowaLektorB2B2023,
      props: true
    },
    {
      path: "/UmowaMetodykProfi",
      name: "UmowaMetodykProfi",
      component: UmowaMetodykProfi,
      props: true
    },
    {
      path: "/UmowaPromocjaProfi",
      name: "UmowaPromocjaProfi",
      component: UmowaPromocjaProfi,
      props: true
    },
    {
      path: "/UmowaBOKProfi",
      name: "UmowaBOKProfi",
      component: UmowaBOKProfi,
      props: true
    },
    {
      path: "/UmowaTechniczniCPProfi",
      name: "UmowaTechniczniCPProfi",
      component: UmowaTechniczniCPProfi,
      props: true
    },
    {
      path: "/UmowaTechniczniKBProfi",
      name: "UmowaTechniczniKBProfi",
      component: UmowaTechniczniKBProfi,
      props: true
    },
    {
      path: "/UmowaTechniczniOMProfi",
      name: "UmowaTechniczniOMProfi",
      component: UmowaTechniczniOMProfi,
      props: true
    },
    {
      path: "/WzorUmowaZlecenieProfi",
      name: "WzorUmowaZlecenieProfi",
      component: WzorUmowaZlecenieProfi,
      props: true
    },
    {
      path: "/UmowaFotoZimowiska2023",
      name: "UmowaFotoZimowiska2023",
      component: UmowaFotoZimowiska2023,
      props: true
    },
    {
      path: "/UmowaWychowawcaZimowiska2023",
      name: "UmowaWychowawcaZimowiska2023",
      component: UmowaWychowawcaZimowiska2023,
      props: true
    },
    {
      path: "/UmowaPomocTechnicznaZimowiska2023",
      name: "UmowaPomocTechnicznaZimowiska2023",
      component: UmowaPomocTechnicznaZimowiska2023,
      props: true
    },
    {
      path: "/UmowaKierownikZimowiska2023",
      name: "UmowaKierownikZimowiska2023",
      component: UmowaKierownikZimowiska2023,
      props: true
    },
    {
      path: "/UmowaInstruktorWewnetrznyZimowiska2023",
      name: "UmowaInstruktorWewnetrznyZimowiska2023",
      component: UmowaInstruktorWewnetrznyZimowiska2023,
      props: true
    },
    {
      path: "/UmowaInstruktorZewnetrznyZimowiska2023",
      name: "UmowaInstruktorZewnetrznyZimowiska2023",
      component: UmowaInstruktorZewnetrznyZimowiska2023,
      props: true
    },
    {
      path: "/WzorUmowaTechniczniCPProfi",
      name: "WzorUmowaTechniczniCPProfi",
      component: WzorUmowaTechniczniCPProfi,
      props: true
    },
    {
      path: "/WzorUmowaManagerPlacowkiEdukacyjnej2023",
      name: "WzorUmowaManagerPlacowkiEdukacyjnej2023",
      component: WzorUmowaManagerPlacowkiEdukacyjnej2023,
      props: true
    },
    {
      path: "/UmowaSpecjalistaRozwojSieciSprzedazy2023",
      name: "UmowaSpecjalistaRozwojSieciSprzedazy2023",
      component: UmowaSpecjalistaRozwojSieciSprzedazy2023,
      props: true
    },
    {
      path: "/WzorUmowaSpecjalistaRozwojSieciSprzedazy2023",
      name: "WzorUmowaSpecjalistaRozwojSieciSprzedazy2023",
      component: WzorUmowaSpecjalistaRozwojSieciSprzedazy2023,
      props: true
    },
    {
      path: "/UmowaAnimatorRozwojSieciSprzedazy2023",
      name: "UmowaAnimatorRozwojSieciSprzedazy2023",
      component: UmowaAnimatorRozwojSieciSprzedazy2023,
      props: true
    },
    {
      path: "/UmowaLektorB2BAngielski2024",
      name: "UmowaLektorB2BAngielski2024",
      component: UmowaLektorB2BAngielski2024,
      props: true
    },
    {
      path: "/UmowaLektorAngielski2023",
      name: "UmowaLektorAngielski2023",
      component: UmowaLektorAngielski2023,
      props: true
    },
    {
      path: "/UmowaKonsultantCCProfi",
      name: "UmowaKonsultantCCProfi",
      component: UmowaKonsultantCCProfi,
      props: true
    },
    {
      path: "/UmowaKonsultantInfoliniaProfi",
      name: "UmowaKonsultantInfoliniaProfi",
      component: UmowaKonsultantInfoliniaProfi,
      props: true
    },
    {
      path: "/UmowaMlodszySpecjalistaSekcjaSzkolna2023",
      name: "UmowaMlodszySpecjalistaSekcjaSzkolna2023",
      component: UmowaMlodszySpecjalistaSekcjaSzkolna2023,
      props: true
    },
    {
      path: "/WzorUmowaPomocTechnicznaZimowiska2023",
      name: "WzorUmowaPomocTechnicznaZimowiska2023",
      component: WzorUmowaPomocTechnicznaZimowiska2023,
      props: true
    },
    {
      path: "/UmowaHostessaSieciSprzedazy2023",
      name: "UmowaHostessaSieciSprzedazy2023",
      component: UmowaHostessaSieciSprzedazy2023,
      props: true
    },
    {
      path: "/UmowaHostessaSieciSprzedazyBOK2023",
      name: "UmowaHostessaSieciSprzedazyBOK2023",
      component: UmowaHostessaSieciSprzedazyBOK2023,
      props: true
    },
    {
      path: "/UmowaAnimatorBOK2023",
      name: "UmowaAnimatorBOK2023",
      component: UmowaAnimatorBOK2023,
      props: true
    },
    {
      path: "/WzorUmowaHostessaSieciSprzedazy2023",
      name: "WzorUmowaHostessaSieciSprzedazy2023",
      component: WzorUmowaHostessaSieciSprzedazy2023,
      props: true
    },
    {
      path: "/WzorUmowaAnimatorRozwojSieciSprzedazy2023",
      name: "WzorUmowaAnimatorRozwojSieciSprzedazy2023",
      component: WzorUmowaAnimatorRozwojSieciSprzedazy2023,
      props: true
    },
    {
      path: "/WzorUmowaFotoZimowiska2023",
      name: "WzorUmowaFotoZimowiska2023",
      component: WzorUmowaFotoZimowiska2023,
      props: true
    },
    {
      path: "/WzorUmowaWychowawcaZimowiska2023",
      name: "WzorUmowaWychowawcaZimowiska2023",
      component: WzorUmowaWychowawcaZimowiska2023,
      props: true
    },
    {
      path: "/WzorUmowaKierownikZimowiska2023",
      name: "WzorUmowaKierownikZimowiska2023",
      component: WzorUmowaKierownikZimowiska2023,
      props: true
    },
    {
      path: "/WzorUmowaInstruktorWewnetrznyZimowiska2023",
      name: "WzorUmowaInstruktorWewnetrznyZimowiska2023",
      component: WzorUmowaInstruktorWewnetrznyZimowiska2023,
      props: true
    },
    {
      path: "/WzorUmowaInstruktorZewnetrznyZimowiska2023",
      name: "WzorUmowaInstruktorZewnetrznyZimowiska2023",
      component: WzorUmowaInstruktorZewnetrznyZimowiska2023,
      props: true
    },
    {
      path: "/UmowaManager",
      name: "UmowaManager",
      component: UmowaManager,
      props: true
    },
    {
      path: "/UmowaAnimatorEdukacja",
      name: "UmowaAnimatorEdukacja",
      component: UmowaAnimatorEdukacja,
      props: true
    },
    {
      path: "/UmowaHostessaEdukacja",
      name: "UmowaHostessaEdukacja",
      component: UmowaHostessaEdukacja,
      props: true
    },
    {
      path: "/WypowiedzenieB2B",
      name: "WypowiedzenieB2B",
      component: WypowiedzenieB2B,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoB2B",
      name: "WypowiedzenieBezOkresWypoB2B",
      component: WypowiedzenieBezOkresWypoB2B,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieB2B",
      name: "WypowiedzeniePorozumienieB2B",
      component: WypowiedzeniePorozumienieB2B,
      props: true
    },
    {
      path: "/WypowiedzenieB2BTM",
      name: "WypowiedzenieB2BTM",
      component: WypowiedzenieB2BTM,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoB2BTM",
      name: "WypowiedzenieBezOkresWypoB2BTM",
      component: WypowiedzenieBezOkresWypoB2BTM,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieB2BTM",
      name: "WypowiedzeniePorozumienieB2BTM",
      component: WypowiedzeniePorozumienieB2BTM,
      props: true
    },
    {
      path: "/UmowaKierownik2023",
      name: "UmowaKierownik2023",
      component: UmowaKierownik2023,
      props: true
    },
    {
      path: "/UmowaWychowawca2023",
      name: "UmowaWychowawca2023",
      component: UmowaWychowawca2023,
      props: true
    },
    {
      path: "/RegulaminKolonie2023",
      name: "RegulaminKolonie2023",
      component: RegulaminKolonie2023,
      props: true
    },
    {
      path: "/UmowaFotograf2023",
      name: "UmowaFotograf2023",
      component: UmowaFotograf2023,
      props: true
    },
    {
      path: "/UmowaPomocTechniczna2023",
      name: "UmowaPomocTechniczna2023",
      component: UmowaPomocTechniczna2023,
      props: true
    },
    {
      path: "/UmowaKoordynator",
      name: "UmowaKoordynator",
      component: UmowaKoordynator,
      props: true
    },
    {
      path: "/UmowaKoordynatorSprzedaz",
      name: "UmowaKoordynatorSprzedaz",
      component: UmowaKoordynatorSprzedaz,
      props: true
    },
    {
      path: "/KartaBagaz",
      name: "KartaBagaz",
      component: KartaBagaz,
      props: true
    },
    {
      path: "/UmowaInstruktor2023",
      name: "UmowaInstruktor2023",
      component: UmowaInstruktor2023,
      props: true
    },
    {
      path: "/UmowaTeamLeader2023",
      name: "UmowaTeamLeader2023",
      component: UmowaTeamLeader2023,
      props: true
    },
    {
      path: "/UmowaSpecjalistaSprzedaz",
      name: "UmowaSpecjalistaSprzedaz",
      component: UmowaSpecjalistaSprzedaz,
      props: true
    },
    {
      path: "/UmowaKierownikProfi2023",
      name: "UmowaKierownikProfi2023",
      component: UmowaKierownikProfi2023,
      props: true
    },
    {
      path: "/UmowaWychowawcaProfi2023",
      name: "UmowaWychowawcaProfi2023",
      component: UmowaWychowawcaProfi2023,
      props: true
    },
    {
      path: "/UmowaZlecenieRegionAbcd",
      name: "UmowaZlecenieRegionAbcd",
      component: UmowaZlecenieRegionAbcd,
      props: true
    },
    {
      path: "/UmowaB2BRegionAbcd",
      name: "UmowaB2BRegionAbcd",
      component: UmowaB2BRegionAbcd,
      props: true
    },
    {
      path: "/UmowaZlecenieRegionAbcdMG",
      name: "UmowaZlecenieRegionAbcdMG",
      component: UmowaZlecenieRegionAbcdMG,
      props: true
    },
    {
      path: "/UmowaB2BRegionAbcdMG",
      name: "UmowaB2BRegionAbcdMG",
      component: UmowaB2BRegionAbcdMG,
      props: true
    },
    {
      path: "/WzorUmowaZlecenieRegionAbcd",
      name: "WzorUmowaZlecenieRegionAbcd",
      component: WzorUmowaZlecenieRegionAbcd,
      props: true
    },
    {
      path: "/WzorUmowaB2BRegionAbcd",
      name: "WzorUmowaB2BRegionAbcd",
      component: WzorUmowaB2BRegionAbcd,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieRegionAbcd",
      name: "OswiadczenieGenerowanieRegionAbcd",
      component: OswiadczenieGenerowanieRegionAbcd,
      props: true
    },
    {
      path: "/WypowiedzenieRegion",
      name: "WypowiedzenieRegion",
      component: WypowiedzenieRegion,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieRegion",
      name: "WypowiedzeniePorozumienieRegion",
      component: WypowiedzeniePorozumienieRegion,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoRegion",
      name: "WypowiedzenieBezOkresWypoRegion",
      component: WypowiedzenieBezOkresWypoRegion,
      props: true
    },
    {
      path: "/UmowaMetodyk2024",
      name: "UmowaMetodyk2024",
      component: UmowaMetodyk2024,
      props: true
    },
    {
      path: "/UmowaNauczycielOnline2024",
      name: "UmowaNauczycielOnline2024",
      component: UmowaNauczycielOnline2024,
      props: true
    },
    {
      path: "/UmowaLektor2024",
      name: "UmowaLektor2024",
      component: UmowaLektor2024,
      props: true
    },
    {
      path: "/UmowaTworcaTM2024",
      name: "UmowaTworcaTM2024",
      component: UmowaTworcaTM2024,
      props: true
    },
    {
      path: "/UmowaTworcaFabrykaMaterialow2024",
      name: "UmowaTworcaFabrykaMaterialow2024",
      component: UmowaTworcaFabrykaMaterialow2024,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialowNauczycielMetodyk2024",
      name: "UmowaTworcaMaterialowNauczycielMetodyk2024",
      component: UmowaTworcaMaterialowNauczycielMetodyk2024,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanie2024",
      name: "OswiadczenieGenerowanie2024",
      component: OswiadczenieGenerowanie2024,
      props: true
    },
    {
      path: "/WzorOswiadczenieGenerowanie2024",
      name: "WzorOswiadczenieGenerowanie2024",
      component: WzorOswiadczenieGenerowanie2024,
      props: true
    },
    {
      path: "/WzorUmowaTworca2024",
      name: "WzorUmowaTworca2024",
      component: WzorUmowaTworca2024,
      props: true
    },
    {
      path: "/WzorUmowaNauczycielOnline2024",
      name: "WzorUmowaNauczycielOnline2024",
      component: WzorUmowaNauczycielOnline2024,
      props: true
    },
    {
      path: "/WzorUmowaTworcaMaterialowNauczycielMetodyk2024",
      name: "WzorUmowaTworcaMaterialowNauczycielMetodyk2024",
      component: WzorUmowaTworcaMaterialowNauczycielMetodyk2024,
      props: true
    },
    {
      path: "/WzorUmowaMetodyk2024",
      name: "WzorUmowaMetodyk2024",
      component: WzorUmowaMetodyk2024,
      props: true
    },
    {
      path: "/WzorUmowaTworcaFabrykaMaterialow2024",
      name: "WzorUmowaTworcaFabrykaMaterialow2024",
      component: WzorUmowaTworcaFabrykaMaterialow2024,
      props: true
    },
    {
      path: "/UmowaLektorB2B2024",
      name: "UmowaLektorB2B2024",
      component: UmowaLektorB2B2024,
      props: true
    },
    {
      path: "/UmowaMetodykB2B2024",
      name: "UmowaMetodykB2B2024",
      component: UmowaMetodykB2B2024,
      props: true
    },
    {
      path: "/UmowaNauczycielAngielski2024",
      name: "UmowaNauczycielAngielski2024",
      component: UmowaNauczycielAngielski2024,
      props: true
    },
    {
      path: "/UmowaLektorAngielski2024",
      name: "UmowaLektorAngielski2024",
      component: UmowaLektorAngielski2024,
      props: true
    },
    {
      path: "/UmowaFundacja",
      name: "UmowaFundacja",
      component: UmowaFundacja,
      props: true
    },
    {
      path: "/UmowaTutoreKlient",
      name: "UmowaTutoreKlient",
      component: UmowaTutoreKlient,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanie2024Tutore",
      name: "OswiadczenieGenerowanie2024Tutore",
      component: OswiadczenieGenerowanie2024Tutore,
      props: true
    },
    {
      path: "/UmowaAnimatorEdukacjaTutore",
      name: "UmowaAnimatorEdukacjaTutore",
      component: UmowaAnimatorEdukacjaTutore,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieRegionAbcdTutore",
      name: "OswiadczenieGenerowanieRegionAbcdTutore",
      component: OswiadczenieGenerowanieRegionAbcdTutore,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieProfi2024",
      name: "OswiadczenieGenerowanieProfi2024",
      component: OswiadczenieGenerowanieProfi2024,
      props: true
    },
    {
      path: "/UmowaNauczycielOnlineTutore2024",
      name: "UmowaNauczycielOnlineTutore2024",
      component: UmowaNauczycielOnlineTutore2024,
      props: true
    },
    {
      path: "/UmowaMetodykTutore2024",
      name: "UmowaMetodykTutore2024",
      component: UmowaMetodykTutore2024,
      props: true
    },
    {
      path: "/UmowaTworcaMaterialowNauczycielMetodykTutore2024",
      name: "UmowaTworcaMaterialowNauczycielMetodykTutore2024",
      component: UmowaTworcaMaterialowNauczycielMetodykTutore2024,
      props: true
    },
    {
      path: "/WypowiedzenieTutore",
      name: "WypowiedzenieTutore",
      component: WypowiedzenieTutore,
      props: true
    },
    {
      path: "/WypowiedzenieBezOkresWypoTutore",
      name: "WypowiedzenieBezOkresWypoTutore",
      component: WypowiedzenieBezOkresWypoTutore,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieTutore",
      name: "WypowiedzeniePorozumienieTutore",
      component: WypowiedzeniePorozumienieTutore,
      props: true
    },
    {
      path: "/UmowaTworcaFabrykaMaterialowTutore2024",
      name: "UmowaTworcaFabrykaMaterialowTutore2024",
      component: UmowaTworcaFabrykaMaterialowTutore2024,
      props: true
    },
    {
      path: "/UmowaTworcaTD2024",
      name: "UmowaTworcaTD2024",
      component: UmowaTworcaTD2024,
      props: true
    },
    {
      path: "/UmowaAnimatorTutore",
      name: "UmowaAnimatorTutore",
      component: UmowaAnimatorTutore,
      props: true
    },
    {
      path: "/UmowaNauczycielOnlineTutore2024ABCD",
      name: "UmowaNauczycielOnlineTutore2024ABCD",
      component: UmowaNauczycielOnlineTutore2024ABCD,
      props: true
    },
    {
      path: "/UmowaHostessaB2B2024",
      name: "UmowaHostessaB2B2024",
      component: UmowaHostessaB2B2024,
      props: true
    },
    {
      path: "/AneksB2B",
      name: "AneksB2B",
      component: AneksB2B,
      props: true
    },
    {
      path: "/UmowaPromotorMarki",
      name: "UmowaPromotorMarki",
      component: UmowaPromotorMarki,
      props: true
    },
    {
      path: "/AneksTutorePoland2024",
      name: "AneksTutorePoland2024",
      component: AneksTutorePoland2024,
      props: true
    },
    {
      path: "/AneksTutorePoland2024ENG",
      name: "AneksTutorePoland2024ENG",
      component: AneksTutorePoland2024ENG,
      props: true
    },
    {
      path: "/AneksTutore2024",
      name: "AneksTutore2024",
      component: AneksTutore2024,
      props: true
    },
    {
      path: "/AneksTutore2024ENG",
      name: "AneksTutore2024ENG",
      component: AneksTutore2024ENG,
      props: true
    },
    {
      path: "/AneksB2BTutorePoland",
      name: "AneksB2BTutorePoland",
      component: AneksB2BTutorePoland,
      props: true
    },
    {
      path: "/AneksB2BTutorePolandENG",
      name: "AneksB2BTutorePolandENG",
      component: AneksB2BTutorePolandENG,
      props: true
    },
    {
      path: "/AneksB2BTutore",
      name: "AneksB2BTutore",
      component: AneksB2BTutore,
      props: true
    },
    {
      path: "/AneksB2BTutoreENG",
      name: "AneksB2BTutoreENG",
      component: AneksB2BTutoreENG,
      props: true
    },
    {
      path: "/UmowaHostessaTutorePolandB2B",
      name: "UmowaHostessaTutorePolandB2B",
      component: UmowaHostessaTutorePolandB2B,
      props: true
    },
    {
      path: "/WypowiedzenieRegionTutore",
      name: "WypowiedzenieRegionTutore",
      component: WypowiedzenieRegionTutore,
      props: true
    },
    {
      path: "/WypowiedzeniePorozumienieRegionTutore",
      name: "WypowiedzeniePorozumienieRegionTutore",
      component: WypowiedzeniePorozumienieRegionTutore,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanie2024TutoreMale",
      name: "OswiadczenieGenerowanie2024TutoreMale",
      component: OswiadczenieGenerowanie2024TutoreMale,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanie2024AnimatorTutoreDuze",
      name: "OswiadczenieGenerowanie2024AnimatorTutoreDuze",
      component: OswiadczenieGenerowanie2024AnimatorTutoreDuze,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieRegionAbcdTutoreDuze",
      name: "OswiadczenieGenerowanieRegionAbcdTutoreDuze",
      component: OswiadczenieGenerowanieRegionAbcdTutoreDuze,
      props: true
    },
    {
      path: "/AneksNauczycielAnimatorTutoreMale",
      name: "AneksNauczycielAnimatorTutoreMale",
      component: AneksNauczycielAnimatorTutoreMale,
      props: true
    },
    {
      path: "/UmowaNauczycielLektorAnimatorTutoreMale",
      name: "UmowaNauczycielLektorAnimatorTutoreMale",
      component: UmowaNauczycielLektorAnimatorTutoreMale,
      props: true
    },
    {
      path: "/AneksNauczycielAnimatorTutoreDuze",
      name: "AneksNauczycielAnimatorTutoreDuze",
      component: AneksNauczycielAnimatorTutoreDuze,
      props: true
    },
    {
      path: "/UmowaNauczycielLektorAnimatorTutoreDuze",
      name: "UmowaNauczycielLektorAnimatorTutoreDuze",
      component: UmowaNauczycielLektorAnimatorTutoreDuze,
      props: true
    },
    {
      path: "/UmowaAnimatorTutoreMale",
      name: "UmowaAnimatorTutoreMale",
      component: UmowaAnimatorTutoreMale,
      props: true
    },
    {
      path: "/UmowaAnimatorTutoreDuze",
      name: "UmowaAnimatorTutoreDuze",
      component: UmowaAnimatorTutoreDuze,
      props: true
    },
    {
      path: "/AneksAnimatorTutoreMale",
      name: "AneksAnimatorTutoreMale",
      component: AneksAnimatorTutoreMale,
      props: true
    },
    {
      path: "/AneksAnimatorTutoreDuze",
      name: "AneksAnimatorTutoreDuze",
      component: AneksAnimatorTutoreDuze,
      props: true
    },
    {
      path: "/OswiadczenieGenerowanieAngielskiZmienione2023",
      name: "OswiadczenieGenerowanieAngielskiZmienione2023",
      component: OswiadczenieGenerowanieAngielskiZmienione2023,
      props: true
    },
    {
      path: "/UmowaAneksTechniczni2024",
      name: "UmowaAneksTechniczni2024",
      component: UmowaAneksTechniczni2024,
      props: true
    },    {
      path: "/AneksPustyUOP",
      name: "AneksPustyUOP",
      component: AneksPustyUOP,
      props: true
    },
    {
      path: "/AneksStanowiskoWynagrodzenieUOP",
      name: "AneksStanowiskoWynagrodzenieUOP",
      component: AneksStanowiskoWynagrodzenieUOP,
      props: true
    },
    {
      path: "/AneksMiejsceRodzajPracyUOP",
      name: "AneksMiejsceRodzajPracyUOP",
      component: AneksMiejsceRodzajPracyUOP,
      props: true
    },
    {
      path: "/PorozumienieUOP",
      name: "PorozumienieUOP",
      component: PorozumienieUOP,
      props: true
    },
    {
      path: "/PorozumienieRegulaminUOP",
      name: "PorozumienieRegulaminUOP",
      component: PorozumienieRegulaminUOP,
      props: true
    },
    {
      path: "/UmowaNauczyciel2024",
      name: "UmowaNauczyciel2024",
      component: UmowaNauczyciel2024,
      props: true
    },
    {
      path: "/UmowaNauczyciel2024ENG",
      name: "UmowaNauczyciel2024ENG",
      component: UmowaNauczyciel2024ENG,
      props: true
    },
    {
      path: "/UmowaNauczyciel2024TutoreMale",
      name: "UmowaNauczyciel2024TutoreMale",
      component: UmowaNauczyciel2024TutoreMale,
      props: true
    },
    {
      path: "/UmowaNauczyciel2024TutoreMaleENG",
      name: "UmowaNauczyciel2024TutoreMaleENG",
      component: UmowaNauczyciel2024TutoreMaleENG,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2024TutoreMale",
      name: "UmowaB2BNauczyciel2024TutoreMale",
      component: UmowaB2BNauczyciel2024TutoreMale,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2024TutoreMaleENG",
      name: "UmowaB2BNauczyciel2024TutoreMaleENG",
      component: UmowaB2BNauczyciel2024TutoreMaleENG,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2024",
      name: "UmowaB2BNauczyciel2024",
      component: UmowaB2BNauczyciel2024,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2024ENG",
      name: "UmowaB2BNauczyciel2024ENG",
      component: UmowaB2BNauczyciel2024ENG,
      props: true
    },
    {
      path: "/UmowaB2BMetodyk2024TD",
      name: "UmowaB2BMetodyk2024TD",
      component: UmowaB2BMetodyk2024TD,
      props: true
    },
    {
      path: "/UmowaB2BMetodyk2024TM",
      name: "UmowaB2BMetodyk2024TM",
      component: UmowaB2BMetodyk2024TM,
      props: true
    },
    {
      path: "/WypowiedzenieZOkresWypo",
      name: "WypowiedzenieZOkresWypo",
      component: WypowiedzenieZOkresWypo,
      props: true
    },
    {
      path: "/AneksPorozumienieZlecenie",
      name: "AneksPorozumienieZlecenie",
      component: AneksPorozumienieZlecenie,
      props: true
    },
    {
      path: "/AneksPorozumienieB2B",
      name: "AneksPorozumienieB2B",
      component: AneksPorozumienieB2B,
      props: true
    },
    {
      path: "/WypowiedzenieZOkresWypoB2B",
      name: "WypowiedzenieZOkresWypoB2B",
      component: WypowiedzenieZOkresWypoB2B,
      props: true
    },
    {
      path: "/WypowiedzenieZOkresWypoB2BTM",
      name: "WypowiedzenieZOkresWypoB2BTM",
      component: WypowiedzenieZOkresWypoB2BTM,
      props: true
    },
    {
      path: "/OswiadczenieETutor",
      name: "OswiadczenieETutor",
      component: OswiadczenieETutor,
      props: true
    },
    {
      path: "/OswiadczenieILI",
      name: "OswiadczenieILI",
      component: OswiadczenieILI,
      props: true
    },
    {
      path: "/Oswiadczenie25TD",
      name: "Oswiadczenie25TD",
      component: Oswiadczenie25TD,
      props: true
    },
    {
      path: "/Oswiadczenie25TM",
      name: "Oswiadczenie25TM",
      component: Oswiadczenie25TM,
      props: true
    },
    {
      path: "/Oswiadczenie25TDENG",
      name: "Oswiadczenie25TDENG",
      component: Oswiadczenie25TDENG,
      props: true
    },
    {
      path: "/Oswiadczenie25TMENG",
      name: "Oswiadczenie25TMENG",
      component: Oswiadczenie25TMENG,
      props: true
    },
    {
      path: "/UmowaNauczyciel2024eTutorPlus",
      name: "UmowaNauczyciel2024eTutorPlus",
      component: UmowaNauczyciel2024eTutorPlus,
      props: true
    },
    {
      path: "/AneksNauczyciel2024eTutorPlus",
      name: "AneksNauczyciel2024eTutorPlus",
      component: AneksNauczyciel2024eTutorPlus,
      props: true
    },
    {
      path: "/AneksB2BNauczyciel2024eTutorPlus",
      name: "AneksB2BNauczyciel2024eTutorPlus",
      component: AneksB2BNauczyciel2024eTutorPlus,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2024eTutorPlus",
      name: "UmowaB2BNauczyciel2024eTutorPlus",
      component: UmowaB2BNauczyciel2024eTutorPlus,
      props: true
    },
    {
      path: "/UmowaB2BNauczyciel2025eTutorPlus",
      name: "UmowaB2BNauczyciel2025eTutorPlus",
      component: UmowaB2BNauczyciel2025eTutorPlus,
      props: true
    },
    {
      path: "/UmowaNauczyciel2025eTutorPlus",
      name: "UmowaNauczyciel2025eTutorPlus",
      component: UmowaNauczyciel2025eTutorPlus,
      props: true
    },
    {
      path: "/Oswiadczenie25LM",
      name: "Oswiadczenie25LM",
      component: Oswiadczenie25LM,
      props: true
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js